export const InitialValuesExecutionCLass = {
    question0: "",
    question1: "",
    question2: "",
    question3: "",
    executionClassResult1: "",
    executionClassResult2: "",
}